// app/question/test.js

(function () {
    "use strict";
    var controllerId = "asl_pacchetto";
    angular.module("app").controller(controllerId, ["$rootScope", "$scope", "$filter", "$location", "common", "bootstrap.dialog", "$routeParams", "$q", "$uibModal", "datacontext", "sectionMenu", "filterFilter", "$translate", "amMoment", asl_pacchetto]);

    function asl_pacchetto($rootScope, $scope, $filter, $location, common, bDialog, $routeParams, $q, $uibModal, datacontext, sectionMenu, filterFilter, $translate, amMoment) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, "logError");
        var logSuccess = getLogFn(controllerId, "logSuccess");
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard
        var vm = this;
        vm.title = "Pacchetti";
        vm.view = "list";       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        vm.objName = "pacchetti"; //Utilizzato per pannello modale
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;        
        vm.custom = false;
        vm.testId = 0;

        vm.importDisabled = true;
        vm.exportDisabled = false;
        vm.addDisabled = true;
        //vm.readonly = false;
        vm.readonly = true;
        
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;
        
        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ["Validita", "Prezzo", "Titolo", "Ultima Modifica"];
        vm.list.ordine = common.setOrdine(vm.list.ordine);
        vm.ordine = vm.list.ordine[3];

        vm.currentLanguage = $translate.use() || $translate.proposedLanguage();
        vm.stato = [{ 'id': 1, 'name': $translate.instant('InLavorazione') }, { 'id': 3, 'name': $translate.instant('Pubblicato') }];

        vm.numeroTest = [{ 'id': 5, 'name': $translate.instant('Da1A5') }, { 'id': 15, 'name': $translate.instant('Da6A15') }, { 'id': 16, 'name': $translate.instant('PiuDi15') }];
        
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            cerca();
        };

        //Elenchi dettaglio
        vm.list.test = [];
        vm.getRecord = getRecord;
        vm.getListTest = getListTest;

        //Filtro
        vm.filter = {};
        vm.filter.testo = "";
        vm.filter.stato = 0;
        vm.filter.numeroTest = 0;
        vm.fTesto = "";
        vm.fStato = 0;
        vm.fNumeroTest = 0;

        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;
        vm.get = getRecord;
        vm.showTest = showTest;
        vm.goBack = goBack;
       
        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [];
            common.activateController(promises, controllerId)
                .then(function () {
                    if ($routeParams.pacchettoId != null) {
                        setView("detail");
                        vm.testId = ($routeParams.testId != null) ? $routeParams.testId : 0;

                        if (vm.testId != 0)
                            vm.sectionMenu = sectionMenu.setSection("Test");

                        getRecord($routeParams.pacchettoId, 0);
                    }
                });
        }

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {            
            if (view == 'list') {                
                cerca();
            }
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.testo = vm.fTesto == null ? 0 : vm.fTesto;
            vm.filter.stato = vm.fStato == null ? 0 : vm.fStato;
            vm.filter.numeroTest = vm.fNumeroTest == null ? 0 : vm.fNumeroTest;
            vm.filter.data = vm.fData == null ? '' : $filter('date')(vm.fData, vm.format);

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {            
            return datacontext.asl_pacchetto_countByFilter(vm.filter.testo, vm.filter.stato, vm.filter.numeroTest)
                .then(function (data) {
                    if (data) {
                        vm.countRecords = data;
                    }
                });
        }

        function getAllByFilter() {            
            if (vm.loading === true) return;
            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;
            vm.loading = true;
            return datacontext.asl_pacchetto_getAllByFilter(vm.pageSize, vm.page, vm.filter.testo, vm.filter.stato, vm.filter.numeroTest, vm.ordine.value)
                .then(function (data) {
                    if (data.constructor === Array) {
                        vm.page++;
                        data.forEach(function (item) {
                            var DtInsert = $filter("date")(item.DtInsert, "dd/MM/yyyy");
                            var DtUpdate = $filter("date")(item.DtUpdate, "dd/MM/yyyy"); 
                            if (DtInsert != DtUpdate)
                                item.modificato = true;
                            vm.records.push(item);
                        });
                    }
                    vm.loading = false;                                    
                });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {
            return datacontext.pacchetto_get(id).then(function (data) {
                vm.index = index;

                var destinazioni = data.DestinazioniExt.split(', ');
                if (destinazioni.length > 0) {
                    data.DestinazioniExt = '';
                    destinazioni.forEach(function (d) {
                        data.DestinazioniExt += $translate.instant(d) + ', ';
                    });
                    data.DestinazioniExt = data.DestinazioniExt.substring(0, data.DestinazioniExt.length - 2);
                }     

                vm.record = data;
                vm.active = true;
                //vm.record.data = $filter("date")(data.DtUpdate, "dd/MM/yyyy");
                //Azzera liste
                vm.list.test = [];
                countListTest(id);
                //getListTest(id);
                setView("detail");
            });
        }

        //List Methods
        function getListTest(id) {
            if (!id) return;
            return datacontext.pacchettoTest_getAllByPacchetto(id, "titolo").then(function (data) {
                return vm.list.test = data;
            });
        }

        function countListTest(id) {
            if (!id) return;
            return datacontext.pacchettoTest_countAllByPacchetto(id).then(function (data) {
                return vm.countTest = data;
            });
        }

        function showTest(index) {
            if (!index)
                index = 0;

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/adminSL/pacchetto/modal/asl_testShow.html?version=43',
                controller: 'asl_testShow',
                windowClass: 'modal-wide',
                resolve: {
                    pacchettoId: function () {
                        return vm.record.Id;
                    },
                    testIndex: function () {
                        return index;
                    }
                }
            });
        }

        function goBack() {
            if (vm.testId == 0)
                setView('list');
            else
                $location.url("/EDUP_test/" + vm.testId);
        }
    }
})();
